var chunkToChildrenMap = {
	"2372": [
		84781,
		5783,
		72448,
		47575,
		13575,
		12157,
		20794,
		44869,
		87851,
		69791,
		6312,
		41795,
		45062,
		27134,
		91460,
		12044,
		95067,
		65902,
		29210,
		62087,
		82631,
		81796,
		578,
		51672
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));